export const NOTIFICATION_TRADE_CONFIRMED = 'tradeConfirmed_data';
export const NOTIFICATION_SIMPLE = 'simple';
export const NOTIFICATION_ACCOUNT_FUNDS = 'accountfunds_data';
export const NOTIFICATION_MARKET = 'market_data';
export const NOTIFICATION_MARKET_STATUS = 'market_status';
export const NOTIFICATION_CONTRACT = 'contract_data';
export const NOTIFICATION_MARKET_OWNERSHIP = 'marketOwnershipUpdate_data';
export const NOTIFICATION_CONTRACT_OWNERSHIP = 'contractOwnershipUpdate_data';
export const NOTIFICATION_SHARES_TRADED = 'notification_shares_traded';
export const NOTIFICATION_SITE_STATUS = 'site_status';
export const NOTIFICATION_TRADER_LEVEL_CHANGED = 'notification_trade_level_changed';
export const NOTIFICATION_PWMB_DEPOSIT_FINISHED = 'notification_pwmb_deposit_finished';
export const NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION = 'notification_pwmb_deposit_show_confirmation';
export const NOTIFICATION_PWMB_SHOW_ERROR = 'notification_pwmb_show_error';



// WEBPACK FOOTER //
// ./src/services/notifications/notification-types.js